<template>
    <div class="item" :style="{ opacity: isDismissing ? 0.5 : 1 }">
        <div style="padding-top: 10px;">
            <input
                type="checkbox"
                :checked="isChecked"
                @change="$emit('check', itemId)"
            />
        </div>
        <div class="icon" :title="label">
            <i :class="`fa ${icon}`" />
        </div>
        <div class="content">
            <span class="message" v-html="content" />
            <span class="time">
                {{ time }}
            </span>
        </div>
        <div class="right-options">
            <div class="interactions">
                <a v-if="preparingModalTask" class="dismiss" @click.prevent>
                    <img class="spinner" src="assets/ajax-spinner.gif" />
                </a>
                <a
                    href="#"
                    v-else-if="taskUrl"
                    @click.prevent="$emit('view-task', taskStatusId, taskId)"
                    :style="{
                        visibility: isTaskConvertible ? 'visible' : 'hidden'
                    }"
                >
                    <i
                        v-b-tooltip.hover.top
                        title="View task"
                        class="fa fa-external-link-alt"
                    />
                </a>
                <a
                    v-else
                    href="#"
                    @click.prevent="$emit('convert-to-task', itemId)"
                    :style="{
                        visibility: isTaskConvertible ? 'visible' : 'hidden'
                    }"
                >
                    <i
                        v-b-tooltip.hover.top
                        title="Convert to task"
                        class="fa fa-list"
                    />
                </a>

                <a class="dismiss" v-if="isDismissing" @click.prevent>
                    <img class="spinner" src="assets/ajax-spinner.gif" />
                </a>
                <a href="#" @click.prevent="dismiss" class="dismiss" v-else>
                    <i
                        v-b-tooltip.hover.top
                        title="Dismiss"
                        class="fa fa-times"
                    />
                </a>
            </div>
            <div v-if="isTaskConvertible" class="pill-wrapper">
                <span v-if="taskStatusId === 2" class="pill in-progress">
                    In Progress
                </span>
                <span v-else-if="taskStatusId === 1" class="pill completed">
                    Completed
                </span>
                <span v-else-if="taskStatusId === 0" class="pill open">
                    Open
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationService from "@/services/notification.js";

export default {
    props: {
        itemId: {
            type: String
        },
        /**
         * notification type values:
         * REPORT | LAB | PHARMACY | PATIENT | BILLING | SYSTEM | SCHEDULE | DIAGNOSTIC_IMAGE
         */
        type: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        content: {
            type: String,
            default: ""
        },
        time: {
            type: String
        },
        icon: {
            type: String,
            default: "fa-question-circle"
        },
        preparingModalTask: {
            type: Boolean,
            default: false
        },
        isChecked: {
            type: Boolean
        },
        taskInfo: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            isDismissing: false
        };
    },
    computed: {
        isTaskConvertible() {
            return ["LAB", "DIAGNOSTIC_IMAGE", "PHARMACY"].includes(this.type);
        },
        taskStatusId() {
            return this.taskInfo?.status?.id;
        },
        taskId() {
            return this.taskInfo?.id;
        },
        taskUrl() {
            return this.taskInfo?.url;
        }
    },
    methods: {
        async dismiss() {
            try {
                this.isDismissing = true;
                await NotificationService.dismiss([this.itemId]);
                this.isDismissing = false;

                this.$emit("dismiss-item", {
                    id: this.itemId,
                    type: this.type
                });
            } catch (error) {
                this.isDismissing = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.item {
    cursor: default;
    display: grid;
    grid-template-columns: 15px 50px 1fr 70px;
    column-gap: 10px;
    padding: 10px 20px;

    &:hover {
        background: rgba(gray, 0.1);

        .right-options .interactions a {
            color: black;
        }
    }

    .icon {
        display: flex;
        justify-content: center;
        padding-top: 3px;
    }

    .icon i {
        font-size: 2em;
    }

    .content {
        span {
            display: block;

            &.time {
                color: gray;
                font-size: 0.9em;
            }
        }
    }

    .right-options {
        .interactions {
            display: flex;
            justify-content: flex-end;
            gap: 10px;

            a {
                color: #959595;
            }
        }

        .pill-wrapper {
            display: flex;
            justify-content: flex-end;
            margin-top: 3px;

            span.pill {
                white-space: nowrap;
                font-size: 0.8em;
                padding: 1px 5px;
                border-radius: 5px;
                color: white;

                &.in-progress {
                    background-color: #b38727;
                }
                &.completed {
                    background-color: #386fc9;
                }
                &.open {
                    background-color: #22964c;
                }
            }
        }
    }
}
</style>
